const env = process.env;
// @ts-ignore
env.PUBLIC_URL = env.PUBLIC_URL || "";
export const backgroundImage = `${env.PUBLIC_URL}/assets/img/bg.png`;
export const youtubeButton = `${env.PUBLIC_URL}/assets/img/youtube.png`;
